export const FETCH_INSTITUTION_STUDENT_DATA_SUCCESS =
  'FETCH_INSTITUTION_STUDENT_DATA_SUCCESS';
export const FETCH_INSTITUTION_STUDENT_DATA_FAILURE =
  'FETCH_INSTITUTION_STUDENT_DATA_FAILURE';
export const FETCH_INSTITUTION_EXPORTS_START =
  'FETCH_INSTITUTION_EXPORTS_START';
export const FETCH_INSTITUTION_EXPORTS_SUCCESS =
  'FETCH_INSTITUTION_EXPORTS_SUCCESS';
export const FETCH_INSTITUTION_EXPORTS_FAILURE =
  'FETCH_INSTITUTION_EXPORTS_FAILURE';
export const CREATE_INSTITUTION_STUDENT_DATA_EXPORT_STARTED =
  'CREATE_INSTITUTION_STUDENT_DATA_EXPORT_STARTED';
export const CREATE_INSTITUTION_STUDENT_DATA_EXPORT_SUCCESS =
  'CREATE_INSTITUTION_STUDENT_DATA_EXPORT_SUCCESS';
export const DELETE_INSTITUTION_EXPORT_SUCCESS =
  'DELETE_INSTITUTION_EXPORT_SUCCESS';
export const POLL_INSTITUTION_EXPORT_SUCCESS =
  'POLL_INSTITUTION_EXPORT_SUCCESS';
export const POLL_INSTITUTION_EXPORT_STARTED =
  'POLL_INSTITUTION_EXPORT_STARTED';
export const POLL_INSTITUTION_EXPORT_STOPPED =
  'POLL_INSTITUTION_EXPORT_STOPPED';
export const INSTITUTION_STUDENT_DATA_VIEWED =
  'INSTITUTION_STUDENT_DATA_VIEWED';
export const INSTITUTION_STUDENT_DATA_DOWNLOADED =
  'INSTITUTION_STUDENT_DATA_DOWNLOADED';
